export const AppAuthorizedProfiles = {
	MEMBERSHIP: "MEMBERSHIP",
	BACKOFFICE: "BACKOFFICE",
} as const

export type IAuthorizedProfiles =
	(typeof AppAuthorizedProfiles)[keyof typeof AppAuthorizedProfiles]
